import React, { useEffect, useMemo, useRef } from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
export const GlobalSearchTabContent = styled.section`  
  &.is-hidden {
    display: none;
  }
`
interface Props {
  tabs: Map<App.SearchVertical, App.GlobalSearchVerticalTab>
  selectedTabKey?: App.SearchVertical
}

function GlobalSearchTabContents(props: Props) {
  const { selectedTabKey, tabs } = props
  const keysSeen = useRef<Set<App.SearchVertical>>(selectedTabKey ? new Set([selectedTabKey]) : new Set())

  useEffect(() => {
    if (selectedTabKey) {
      keysSeen.current.add(selectedTabKey)
    }
  }, [selectedTabKey])

  const tabsArray = useMemo(() => [...tabs.entries()], [tabs])

  return <>
    {tabsArray.map(([key, tab]) => <GlobalSearchTabContent className={clsx({ 'is-hidden': selectedTabKey !== key })} key={key}>
      {(selectedTabKey === key || keysSeen.current.has(key)) && <tab.Component />}
    </GlobalSearchTabContent>)}
  </>
}

export default GlobalSearchTabContents
